import React, { useCallback } from 'react'
import VirtualOfficesService from 'Services/virtual-offices'

import SelectUser from '../../Users/Forms/Select'

export default ({ virtualOffice, setVirtualOffice }) => {
  const addUser = useCallback(async newUser => {
    if (virtualOffice.users.find(user => user.id === newUser.id))
      return 'The user has already been added'

    const user = await VirtualOfficesService.addUsers({
      virtualOfficeId: virtualOffice.id,
      users: [newUser.id]
    }).catch(err => err.message)
    if (typeof user === 'string') return user

    setVirtualOffice({ ...virtualOffice, users: [...virtualOffice.users, newUser] })
  })

  return <SelectUser buttonText="Add User" onSelect={addUser} />
}
